export const DEFAULT_PAGE_TITLE = 'CAST';
export const ADMIN_PAGE_TITLE = 'CAST Admin';
export const STORE_PAGE_TITLE = 'CAST Store';
